// "ResizeObserver loop limit exceeded" and "ResizeObserver loop completed
// with undelivered notifications" are benign browser warnings: a
// ResizeObserver callback triggered another layout pass in the same frame,
// so the browser deferred one notification to the next tick. The page
// keeps working — but CRA's react-error-overlay surfaces them as fatal
// errors and slams up a runtime-error modal.
//
// The shared Header's overflow-detection observer and Novu's popover
// positioning observers together emit these whenever the inbox dropdown
// opens or closes. Swallow them at the window level so the dev overlay
// stays quiet.

const IGNORED_PREFIXES = [
    "ResizeObserver loop limit exceeded",
    "ResizeObserver loop completed with undelivered notifications",
];

if (typeof window !== "undefined") {
    window.addEventListener("error", (event) => {
        if (event.message && IGNORED_PREFIXES.some((p) => event.message.includes(p))) {
            event.stopImmediatePropagation();
            event.preventDefault();
        }
    });
}

export {};
